module.exports = __webpack_public_path__ + "img/banner01.360a36c8.png";